export default __webpack_public_path__ + "static/2-ba48c087f5fb1ac3b6a5821c5eb41455.png";